import { apiSlice } from "../../app/api/apiSlice"

export const supportApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        requestSupport: builder.mutation({
            query: request => ({
                url: '/support/request',
                method: 'POST',
                body: {
                    ...request
                }
            })
        })
    })
})

export const {
    useRequestSupportMutation
} = supportApiSlice